import React, { memo, useState } from 'react';
import { UpdateGmbLocationParams } from '../../../../requests/partner/gmb-locations';

import WebsiteUrlModal from '../form-modal/WebsiteUrlModal';
import BaseRaw from './BaseRaw';

type Props = {
  label: string;
  value?: string | null;
  handleUpdate?: (params: UpdateGmbLocationParams) => Promise<void>;
  editable?: boolean;
};

const WebsiteUrlRaw: React.FC<Props> = (props) => {
  const editable = props.editable === undefined || props.editable ? true : false;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShow, setIsShow] = useState<boolean>(false);
  const handleModal = () => {
    setIsShow(!isShow);
  };
  const handleSubmit = async (params: UpdateGmbLocationParams): Promise<void> => {
    setIsLoading(true);
    if (props.handleUpdate !== undefined) await props.handleUpdate(params);
    setIsLoading(false);
  };
  return (
    <>
      <BaseRaw
        isLoading={isLoading}
        label={props.label}
        value={props.value || '未設定'}
        handleModal={editable ? handleModal : undefined}
      />
      {editable ? (
        <WebsiteUrlModal
          isShow={isShow}
          label={props.label}
          value={props.value || '未設定'}
          handleModal={handleModal}
          handleUpdate={handleSubmit}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(WebsiteUrlRaw);
